import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const DashboardMobileNav = () => {
  const location = useLocation();
  const userInfo = JSON.parse(sessionStorage.getItem("info") || "{}");
  const hasSession = Boolean(sessionStorage.getItem("token"));
  const hiddenRoutes = [
    "/login",
    "/register",
    "/forgot-password",
    "/reset-password",
    "/download-apk",
    "/validate-plan",
  ];

  if (!hasSession || hiddenRoutes.some((path) => location.pathname.startsWith(path))) {
    return null;
  }

  const isCustomer = userInfo?.type === "customer";
  const homePath = userInfo?.type === "financer" ? "/employee-dashboard" : isCustomer ? "/customers" : "/index";
  const items = isCustomer
    ? [
        { label: "Overview", icon: "ti ti-home-2", path: homePath },
        { label: "Calculator", icon: "ti ti-calculator", path: "/emi_calculator" },
        { label: "EMI Records", icon: "ti ti-receipt-2", path: "/emis-records" },
      ]
    : [
        { label: "Home", icon: "ti ti-home-2", path: homePath },
        { label: "Customers", icon: "ti ti-users", path: "/customers" },
        { label: "Loans", icon: "ti ti-wallet", path: "/loanstatus" },
      ];

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/login";
  };

  return (
    <nav className="native-bottom-nav" aria-label="Primary mobile navigation">
      {items.map((item) => (
        <NavLink
          key={item.label}
          to={item.path}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          <span className="native-bottom-nav__icon" aria-hidden="true">
            <i className={item.icon} />
          </span>
          <span>{item.label}</span>
        </NavLink>
      ))}
      <button type="button" onClick={handleLogout} aria-label="Logout">
        <span className="native-bottom-nav__icon" aria-hidden="true">
          <i className="ti ti-logout" />
        </span>
        <span>Logout</span>
      </button>
    </nav>
  );
};

export default DashboardMobileNav;
